<template>
    <div class="card-wrapper ">
      <div class="user-pic">
        <img class="" :src="image" alt="alt"/>
      </div>
      <div class="name">
        <slot name="p-1"></slot>
      </div>

      <div class="card-btn">

        <slot name="p-2"></slot>
      </div>
    </div>

</template>


<script>
export default {
  props: {
    image: {
      default: 'https://picsum.photos/300/300',
    },
    alt: {
      default: 'mix it web',
    }
  },
  name: "C800",
};
</script>


<style scoped>
.card-wrapper {
  position: relative;
  height: 180px;
  width: 300px;
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: 0.5s;
  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.3);
}

.card-wrapper:hover {
  height: 420px;
  width: 350px;
  transition: 0.5s;
}

.card-wrapper:hover .user-pic {
  height: 250px;
  width: 250px;
  transition: 0.5s;
}

.user-pic {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: auto;
  top: -75px;
  object-fit: cover;
  width: 150px;
  height: 150px;
  background-color: var(--primary);
  border-radius: 10px;
  box-shadow: 0px 15px 50px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  transition: 0.5s;
}

.user-pic img {
  height: 100%;
  width: 100%;
  display: block;
  margin-left: -25%;
  object-fit: cover;
}

.name {
  text-align: center;
  position: relative;
  top: 100px;
  transition: 0.5s;
}

.card-wrapper:hover .name {
  top: 200px;
}

.social-details {
  position: relative;
  top: 100px;
  display: flex;
  justify-content: center;
  text-align: center;
  gap: 30px;
  opacity: 0;
  transition: 0.5s;
}

.card-wrapper:hover .social-details {
  opacity: 1;
  position: relative;
  top: 200px;
}

.card-btn {
  position: relative;
  top: 200px;
  display: flex;
  justify-content: space-evenly;
  gap: 30px;
  padding: 0 50px;
  opacity: 0;
  transition: 0.1s;
}

.card-wrapper:hover .card-btn {
  opacity: 1;
  transition-delay: 0.3s;
}



</style>
